// firebase-config.js (stored in Shopify's assets folder)

// Import the functions you need from the SDKs you need
import { initializeApp } from "https://www.gstatic.com/firebasejs/11.1.0/firebase-app.js";
import { getAnalytics } from "https://www.gstatic.com/firebasejs/11.1.0/firebase-analytics.js";
import { getFirestore } from "https://www.gstatic.com/firebasejs/11.1.0/firebase-firestore.js";

// You can add more imports here if you need other Firebase services, e.g. Firestore, Auth, etc.

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD9OT5CmXBnTUwnAOzNvmzDvIQdyViePKI",
  authDomain: "find-me-33146.firebaseapp.com",
  projectId: "find-me-33146",
  storageBucket: "find-me-33146.firebasestorage.app",
  messagingSenderId: "502405578747",
  appId: "1:502405578747:web:cddddb86533b7646a4555e",
  measurementId: "G-0278CF5438"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

// If you need to export anything for use in other modules, you can do so here:
export { app, analytics, db };
